export const POLL_INTERVAL = 60*1000
export const LONG_POLL_INTERVAL = 60*1000
export const VERY_LONG_POLL_INTERVAL = 60 * 1000